import { Mail, MapPin, Phone } from "lucide-react";
import { resort } from "@/data/resort";
import { ResortLink } from "../resort-button";
import { Reveal } from "../reveal";

const methods = [
  {
    id: "call",
    icon: Phone,
    title: resort.phone,
    copy: "Have a question? Give Auburn RV Resort a call.",
    cta: "Call Now",
    href: resort.phoneHref,
  },
  {
    id: "email",
    icon: Mail,
    title: resort.email,
    copy: "Send us an email and our team will get back to you.",
    cta: "Send Email",
    href: `mailto:${resort.email}`,
  },
  {
    id: "visit",
    icon: MapPin,
    title: "Auburn RV Resort",
    copy: `${resort.address.street}\n${resort.address.city}, ${resort.address.state} ${resort.address.zip}`,
    cta: "Get Directions",
    href: resort.directionsUrl,
    external: true,
  },
];

export function ContactMethods() {
  return (
    <section aria-label="Quick contact options" className="bg-secondary/40 py-10 md:py-14">
      <div className="shell grid gap-6 lg:grid-cols-3">
        {methods.map((method, i) => {
          const Icon = method.icon;
          return (
            <Reveal key={method.id} delay={i * 0.06}>
              <article className="flex h-full flex-col border border-border bg-card p-7 md:p-8">
                <span className="flex size-12 items-center justify-center rounded-full border border-border bg-secondary/50 text-primary">
                  <Icon className="size-5" strokeWidth={1.5} />
                </span>
                <h2 className="font-display mt-6 text-2xl tracking-tight break-words">
                  {method.title}
                </h2>
                <p className="mt-3 flex-1 whitespace-pre-line text-sm leading-relaxed text-muted-foreground">
                  {method.copy}
                </p>
                <ResortLink
                  variant="outline"
                  href={method.href}
                  className="mt-8 w-full"
                  {...(method.external
                    ? { target: "_blank", rel: "noopener noreferrer" }
                    : {})}
                >
                  {method.cta}
                </ResortLink>
              </article>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
